import { UnorderedListOutlined } from '@ant-design/icons'
import { clientRouteDescriptors } from '@/features/client/routing'
import Admin from '../../pages/Admin'
import FileUploadRules from '../../pages/FileUploadRules'
import { permissions } from '../../types/authorization'
import type { ProtectedRouteDescriptor } from '../types'

export const manageRoutes: ProtectedRouteDescriptor[] = [
  ...clientRouteDescriptors,
  {
    key: 'admin',
    path: 'admin',
    element: <Admin />,
    access: { anyOf: [permissions.viewAdminUser] },
    nav: {
      sectionKey: 'manage',
      label: 'DI Users',
      Icon: UnorderedListOutlined,
      order: 20,
    },
  },
  {
    key: 'file-upload-rules',
    path: 'fileupload/rules',
    element: <FileUploadRules />,
    access: { anyOf: [permissions.viewAdminUser] },
  },
]
